import { APIConfigSet } from '../../dao-generator';

/*
 * 组织模块
 */
const orgModule: APIConfigSet = {
  // 获取自定义域名信息
  getOrgCustomDomain: {
    method: 'get',
    path: '/user/v1/organization/{organizationId}/custom-domain',
    queryKeys: { required: ['user_token'] },
    autoParams: { user_token: '', organizationId: '' },
  },
  // 创建自定义域名
  createOrgCustomDomain: {
    method: 'put',
    path: '/user/v1/organization/{organizationId}/custom-domain',
    queryKeys: { required: ['user_token'] },
    bodyKeys: { required: ['domain', 'key', 'cert'], noRequired: ['icp', 'psb', 'title'] },
    autoParams: { user_token: '', organizationId: '' },
  },
  // 更新自定义域名
  updateOrgCustomDomain: {
    method: 'post',
    path: '/user/v1/organization/{organizationId}/custom-domain',
    queryKeys: { required: ['user_token'] },
    bodyKeys: { required: ['domain'], noRequired: ['key', 'cert', 'icp', 'psb', 'title'] },
    autoParams: { user_token: '', organizationId: '' },
  },
  // 解绑自定义域名
  unbindOrgCustomDomain: {
    method: 'delete',
    path: '/user/v1/organization/{organizationId}/custom-domain',
    queryKeys: { required: ['user_token'] },
    autoParams: { user_token: '', organizationId: '' },
  },
  // 列出当前登录用户所属组织
  getUserOrg: {
    method: 'get',
    path: '/user/v1/organization',
    queryKeys: { required: ['user_token'] },
    autoParams: { user_token: '' },
  },
  // 登录进指定组织
  loginOrg: {
    method: 'post',
    path: '/user/v1/organization/{organizationId}',
    queryKeys: { required: ['user_token'] },
    autoParams: { user_token: '' },
  },
  // 获取组织信息
  getOrgInfo: {
    method: 'get',
    path: '/user/v1/organization/{organizationId}',
    queryKeys: { required: ['user_token'] },
    autoParams: {
      organizationId: '',
      user_token: '',
    },
  },
  // 查询组织空间总使用量
  getOrgSpace: {
    method: 'get',
    path: '/user/v1/organization/{organizationId}/usage',
    queryKeys: { required: ['user_token'] },
    autoParams: {
      organizationId: '',
      user_token: '',
    },
  },
  // 获取组织分享列表
  orgShareList: {
    method: 'get',
    path: '/user/v1/organization/{organizationId}/share-list',
    queryKeys: {
      required: ['user_token'],
      noRequired: [
        'page',
        'page_size',
        'order_by',
        'order_by_type',
        'name',
        'expire_time_start',
        'expire_time_end',
        'user_filter',
      ],
    },
    autoParams: {
      organizationId: '',
      user_token: '',
    },
  },
  getGroupShareList: {
    method: 'get',
    path: '/user/v1/group/{organizationId}/{groupId}/share-list',
    queryKeys: {
      required: ['user_token'],
      noRequired: [
        'page',
        'page_size',
        'order_by',
        'order_by_type',
        'name',
        'expire_time_start',
        'expire_time_end',
        'user_filter',
      ],
    },
    autoParams: {
      organizationId: '',
      user_token: '',
    },
  },
  // 获取组织文件权限角色列表
  getRoleList: {
    method: 'get',
    path: '/user/v1/organization/{organizationId}/role-list',
    queryKeys: { required: ['user_token'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 创建角色列表
  createRoleList: {
    method: 'post',
    path: '/user/v1/authority/{organizationId}/role-list',
    queryKeys: { required: ['user_token'] },
    bodyKeys: 'custom',
    autoParams: { organizationId: '', user_token: '' },
  },
  // 更新角色列表
  updateRoleList: {
    method: 'put',
    path: '/user/v1/authority/{organizationId}/role-list',
    queryKeys: { required: ['user_token'] },
    bodyKeys: 'custom',
    autoParams: { organizationId: '', user_token: '' },
  },
  // 删除自定义角色
  deleteRoleList: {
    method: 'post',
    path: '/user/v1/authority/{organizationId}/role-list',
    actionKey: 'delete',
    queryKeys: { required: ['user_token'] },
    bodyKeys: { required: ['roleIds', 'replaceRoleId'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 获取企业Logo简单上传文件参数
  putOrgLogo: {
    method: 'put',
    path: '/user/v1/file/organization-logo/{organizationId}',
    queryKeys: { required: ['ext', 'user_token'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 确认上传企业Logo
  postOrgLogo: {
    method: 'post',
    path: '/user/v1/file/organization-logo/{organizationId}/{filePath}',
    queryKeys: { required: ['user_token'] },
    autoParams: { organizationId: '', user_token: '' },
  },
};

/*
 * 空间（通用）模块
 */
const spaceModule: APIConfigSet = {
  // 列出个人空间
  hasPersonalSpace: {
    method: 'get',
    path: '/user/v1/space/{organizationId}',
    queryKeys: { required: ['user_token'] },
    autoParams: {
      organizationId: '',
      user_token: '',
    },
  },
  // 列出团队空间
  listTeamSpace: {
    method: 'get',
    path: '/user/v1/space/{organizationId}/team/{teamId}',
    queryKeys: { required: ['user_token'] },
    autoParams: {
      organizationId: '',
      user_token: '',
    },
  },
  // 设置团队空间容量（仅管理员）
  setTeamSpace: {
    method: 'post',
    path: '/user/v1/quota/{organizationId}/team/{teamId}',
    queryKeys: { required: ['user_token'] },
    bodyKeys: { noRequired: ['capacity', 'openSpace'] },
    autoParams: {
      organizationId: '',
      user_token: '',
    },
  },
  // (目前无用，此接口在 ATM 单独调用) 获取个人空间信息和访问令牌
  getSpaceInfo: {
    method: 'post',
    path: '/user/v1/space/{organizationId}/personal',
    queryKeys: { required: ['user_token'], noRequired: ['local_sync_id'] },
    autoParams: {
      organizationId: '',
      user_token: '',
    },
  },
  // (目前无用，此接口在 ATM 单独调用) 获取指定空间的 accessToken
  getSpaceAccessToken: {
    method: 'post',
    path: '/user/v1/space/{organizationId}/token/{spaceId}',
    queryKeys: {
      required: ['user_token'],
      noRequired: ['local_sync_id'],
    },
    autoParams: {
      organizationId: '',
      user_token: '',
    },
  },
  // 设置个人空间容量（仅管理员)
  setCapacity: {
    method: 'post',
    path: '/user/v1/quota/{organizationId}/personal/{userId}',
    queryKeys: { required: ['user_token'] },
    bodyKeys: { noRequired: ['capacity'] },
    autoParams: {
      organizationId: '',
      user_token: '',
    },
  },
  // 列出团队空间
  getTeamSpace: {
    method: 'get',
    path: '/user/v1/space/{organizationId}/team/{teamId}',
    queryKeys: { required: ['user_token'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 根据团队的spaceId获取团队空间动态列表（可根据日期过滤）
  getDynamics: {
    method: 'post',
    path: '/user/v1/dynamic/{organizationId}/list',
    queryKeys: { required: ['user_token'] },
    autoParams: { organizationId: '', user_token: '', spaceId: '' },
    bodyKeys: {
      required: ['startTime', 'endTime', 'spaceId', 'spaceOrgId'],
      noRequired: ['dirPath', 'groupBy', 'actionTypeDetail'],
    },
  },
  getDynamicsMore: {
    method: 'get',
    path: '/user/v1/dynamic/{organizationId}/{searchId}',
    queryKeys: { required: ['user_token', 'searchId', 'space_org_id'], noRequired: ['marker', 'groupBy'] },
    autoParams: { organizationId: '', user_token: '', spaceId: '' },
  },
  // 获取工作台的动态
  getWorkbenchDynamic: {
    method: 'post',
    path: '/user/v1/dynamic/{organizationId}/workbench-list',
    queryKeys: { required: ['user_token'] },
    autoParams: { organizationId: '', user_token: '' },
    bodyKeys: {
      required: ['startTime', 'endTime'],
      noRequired: ['actionTypeDetail', 'onlyGroup'],
    },
  },
};

/**
 * 创建搜索任务接口
 */
const searchTaskModule: APIConfigSet = {
  // 创建搜索任务（搜索目录与文件）
  createSearchTask: {
    method: 'post',
    path: '/user/v1/directory-search/{organizationId}/global-search?user_token={userToken}',
    bodyKeys: {
      required: ['keyword', 'accurate'],
      noRequired: [
        'scope',
        'type',
        'modificationTimeStart',
        'modificationTimeEnd',
        'minFileSize',
        'maxFileSize',
        'creators',
        'searchBy',
        'marker',
        'limit',
        'orderBy',
        'orderByType',
        'spaceId',
        'spaceOrgId',
      ],
    },
    autoParams: { organizationId: '', user_token: '' },
  },
};

/**
 * 界面定制
 */
const orgLogoModule: APIConfigSet = {
  // 更新企业其他信息
  updateOrgInfo: {
    method: 'put',
    path: '/user/v1/organization/{organizationId}',
    queryKeys: { required: ['user_token'] },
    bodyKeys: { noRequired: ['name', 'extensionData'] },
    autoParams: {
      organizationId: '',
      user_token: '',
    },
    defaultParams: {
      canPreview: true,
      canDownload: true,
      canSaveToNetDisc: true,
      linkToLatestVersion: true,
    },
  },
  // 重置&删除问卷调查
  deleteSurvey: {
    method: 'delete',
    path: '/user/v1/survey/{organizationId}',
    queryKeys: { required: ['user_token'] },
    bodyKeys: { noRequired: ['data', 'type'] },
    autoParams: {
      organizationId: '',
      user_token: '',
    },
  },
  // 创建问卷调查
  createSurvey: {
    method: 'put',
    path: '/user/v1/survey/{organizationId}',
    queryKeys: { required: ['user_token'] },
    bodyKeys: { noRequired: ['type', 'data', 'addFlag'] },
    autoParams: {
      organizationId: '',
      user_token: '',
    },
  },
  // 获取调查结果
  getSurvey: {
    method: 'get',
    path: '/user/v1/survey/{organizationId}',
    queryKeys: { required: ['user_token'] },
    bodyKeys: { noRequired: ['data', 'type'] },
    autoParams: {
      organizationId: '',
      user_token: '',
    },
  },
};

/**
 * 回收站接口
 */
const recycleModule: APIConfigSet = {
  // 获取回收站目录列表
  listRecycled: {
    method: 'post',
    path: '/user/v1/recycled/{organizationId}/list',
    queryKeys: {
      required: ['user_token'],
      noRequired: ['marker', 'limit', 'page', 'pageSize', 'order_by', 'order_by_type', 'removed_by'],
    },
    bodyKeys: { noRequired: ['spaceItems', 'withAllTeamSpace', 'withAllGroupSpace'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 恢复指定回收站项目（可批量）
  restoreRecycled: {
    method: 'post',
    path: '/user/v1/recycled/{organizationId}',
    queryKeys: { required: ['user_token'] },
    bodyKeys: { required: ['recycledItems'] },
    actionKey: 'restore',
    autoParams: { organizationId: '', user_token: '' },
  },
  // 永久删除指定回收站项目(可批量)
  deleteRecycled: {
    method: 'post',
    path: '/user/v1/recycled/{organizationId}',
    queryKeys: { required: ['user_token'] },
    bodyKeys: { required: ['recycledItems'], noRequired: ['withAllGroups'] },
    actionKey: 'delete',
    autoParams: { organizationId: '', user_token: '' },
  },
  // 获取回收站目录详情
  getRecycledItemInfo: {
    method: 'get',
    path: '/user/v1/recycled/{organizationId}/{spaceId}/{recycledItemId}',
    actionKey: 'info',
    queryKeys: { required: ['user_token', 'recycledItemId', 'spaceId', 'spaceOrgId'] },
    autoParams: { organizationId: '', user_token: '', spaceId: '' },
  },
};

/**
 * 分享模块
 */
const shareModule: APIConfigSet = {
  // 分享文件，获取分享链接 (未分享，触发分享)
  getShareLink: {
    method: 'post',
    path: '/user/v1/share/{organizationId}',
    queryKeys: { required: ['user_token'] },
    bodyKeys: {
      required: [
        'name',
        'directoryInfoList',
        'expireTime',
        'isPermanent',
        'canModify',
        'canPreview',
        'canDownload',
        'canSaveToNetDisc',
        'linkToLatestVersion',
      ],
      noRequired: ['extractionCode', 'previewCount', 'downloadCount', 'watermarkText'],
    },
    autoParams: {
      organizationId: '',
      user_token: '',
    },
    defaultParams: {
      canModify: false,
      canPreview: false,
      canDownload: false,
      canSaveToNetDisc: false,
      linkToLatestVersion: true,
    },
  },
  // 获取分享链接信息（打开分享 url 时查询）
  getSharedLinkDetail: {
    method: 'get',
    path: '/user/v1/share/url-detail/{shareToken}',
  },
  // 保存至网盘时，将欲保存的文件列表保存在后端换取 code
  saveShareCode: {
    method: 'post',
    path: '/user/v1/store',
    queryKeys: { noRequired: ['user_token', 'access_token', 'period'] },
    bodyKeys: { required: ['paths', 'items'] },
  },
  // 验证提取码（用户未登录的时候需要传device_id方便后台记录日志）
  verifyExtractionCode: {
    method: 'get',
    path: '/user/v1/share/verify-extraction-code/{shareToken}',
    queryKeys: {
      required: ['extraction_code', 'device_id'],
      noRequired: ['user_token', 'captchaTicket', 'captchaRandstr'],
    },
    autoParams: { user_token: '' },
  },
  // 修改分享链接
  updateSharedLink: {
    method: 'post',
    path: '/user/v1/share/{organizationId}/update/{shareId}',
    queryKeys: { required: ['user_token'] },
    bodyKeys: {
      required: [
        'isPermanent',
        'extractionCode',
        'linkToLatestVersion',
        'canPreview',
        'canDownload',
        'canSaveToNetDisc',
        'canModify',
      ],
      noRequired: ['previewCount', 'downloadCount', 'expireTime', 'watermarkText'],
    },
    autoParams: { organizationId: '', user_token: '' },
    defaultParams: {
      canModify: false,
      canPreview: false,
      canDownload: false,
      canSaveToNetDisc: false,
      linkToLatestVersion: true,
    },
  },
  // 删除分享链接
  deleteSharedLinks: {
    method: 'post',
    path: '/user/v1/share/{organizationId}/delete',
    queryKeys: { noRequired: ['user_token'] },
    bodyKeys: 'custom',
    autoParams: { organizationId: '', user_token: '' },
  },
  // 获取链接项详情（已分享成功）
  getSharedLinkItem: {
    method: 'get',
    path: '/user/v1/share/{organizationId}/detail/{shareId}',
    queryKeys: { required: ['user_token'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 获取外链列表（获取我分享的链接）
  getSharedLinkList: {
    method: 'get',
    path: '/user/v1/share/{organizationId}/list',
    queryKeys: { required: ['user_token', 'page', 'page_size'], noRequired: ['order_by', 'order_by_type'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 获取某个分享外链的访问列表
  getSharedLinkLogList: {
    method: 'get',
    path: '/user/v1/external-link/{organizationId}/list/{shareId}',
    queryKeys: { required: ['user_token', 'shareId', 'page', 'pageSize'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 分享单个文件
  getSingleFileShareLink: {
    method: 'post',
    path: '/user/v1/share/{organizationId}/single-file',
    queryKeys: { required: ['user_token'], noRequired: ['page_type'] },
    bodyKeys: {
      required: [
        'name',
        'directoryInfo',
        'expireTime',
        'isPermanent',
        'canPreview',
        'canDownload',
        'canSaveToNetDisc',
        'canModify',
        'linkToLatestVersion',
      ],
      noRequired: ['extractionCode'],
    },
    autoParams: {
      organizationId: '',
      user_token: '',
    },
    defaultParams: {
      canPreview: false,
      canDownload: false,
      canSaveToNetDisc: false,
      canModify: false,
      linkToLatestVersion: true,
    },
  },
};

/**
 * code存取查
 */
const codeStoreModule: APIConfigSet = {
  saveCodeInfo: {
    method: 'post',
    path: '/user/v1/store',
    queryKeys: { noRequired: ['user_token', 'access_token', 'period'] },
    bodyKeys: { noRequired: ['routerName', 'spaceInfo', 'currPath', 'downloadData'] },
    autoParams: { user_token: '' },
  },
  // 查询code存储信息
  getCodeInfo: {
    method: 'get',
    path: '/user/v1/store/{code}',
    queryKeys: { noRequired: ['user_token', 'access_token'] },
    autoParams: { user_token: '' },
  },
  // 查询code访问次数
  checkCodeVisit: {
    method: 'get',
    path: '/user/v1/store/{code}',
    actionKey: 'visits',
    queryKeys: { noRequired: ['user_token', 'access_token'] },
    autoParams: { user_token: '' },
  },
};

/**
 * 消息通知
 */
const mesageModule: APIConfigSet = {
  // 查询消息列表
  listMessage: {
    method: 'get',
    path: '/user/v1/message/{organizationId}',
    queryKeys: { required: ['user_token', 'page', 'page_size', 'type', 'read_state'] },
    autoParams: {
      organizationId: '',
      user_token: '',
    },
    defaultParams: {
      page: 1,
      page_size: 50,
      type: 0,
      read_state: 0,
    },
  },
  // 标记所有消息已读
  readAllMessage: {
    method: 'put',
    path: '/user/v1/message/{organizationId}/read',
    actionKey: 'all',
    queryKeys: { required: ['user_token', 'type'] },
    autoParams: {
      organizationId: '',
      user_token: '',
    },
    defaultParams: { type: 0 },
  },
  // 删除所有消息
  deleteAllMessage: {
    method: 'post',
    path: '/user/v1/message/{organizationId}/delete',
    queryKeys: { required: ['user_token', 'type'] },
    autoParams: {
      organizationId: '',
      user_token: '',
    },
    defaultParams: { type: 0 },
  },
  // 删除某一条消息
  deleteMessageItem: {
    method: 'delete',
    path: '/user/v1/message/{organizationId}/{messageId}',
    queryKeys: { required: ['user_token'] },
    autoParams: {
      organizationId: '',
      user_token: '',
    },
  },
  // 查询用户接收消息配置
  getSettingConfig: {
    method: 'get',
    path: '/user/v1/message/{organizationId}/settings',
    queryKeys: { required: ['user_token'] },
    autoParams: {
      organizationId: '',
      user_token: '',
    },
  },
  // 修改用户接收消息配置
  updateSettingConfig: {
    method: 'put',
    path: '/user/v1/message/{organizationId}/settings',
    queryKeys: { required: ['user_token'] },
    bodyKeys: { required: ['receiveMessageConfig'] },
    autoParams: {
      organizationId: '',
      user_token: '',
    },
  },

  // 批量删除消息
  deleteMessageList: {
    method: 'post',
    actionKey: 'part',
    path: '/user/v1/message/{organizationId}/delete',
    queryKeys: { required: ['user_token', 'type'] },
    bodyKeys: { required: ['messageIdList'] },
    autoParams: {
      organizationId: '',
      user_token: '',
    },
    defaultParams: { type: 0 },
  },

  // 批量标记消息已读
  readMessageList: {
    method: 'put',
    path: '/user/v1/message/{organizationId}/read',
    queryKeys: { required: ['user_token'] },
    bodyKeys: { required: ['messageIdList'] },
    autoParams: {
      organizationId: '',
      user_token: '',
    },
  },
};

/**
 * 企微登录配置
 */
const weworkConfigModule: APIConfigSet = {
  // 获取组织企业微信配置参数
  getWeworkConfig: {
    method: 'get',
    path: '/user/v1/integration/{organizationId}/wework/settings',
    queryKeys: { required: ['user_token'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 更新组织企业微信配置参数
  updateWeworkConfig: {
    method: 'post',
    path: '/user/v1/integration/{organizationId}/wework/settings',
    queryKeys: { required: ['user_token'] },
    bodyKeys: { noRequired: ['corpid', 'agentId', 'secret', 'autoOrgSyncEnabled'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 清除企微配置
  removeWeworkConfig: {
    method: 'post',
    path: '/user/v1/integration/{organizationId}/wework/settings/cancel',
    queryKeys: { required: ['user_token'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 验证组织企业微信配置参数
  checkWeworkConfig: {
    method: 'post',
    path: '/user/v1/integration/{organizationId}/wework/settings/check',
    queryKeys: { required: ['user_token'] },
    bodyKeys: { required: ['corpid', 'agentId', 'secret'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  triggerSyncOrg: {
    method: 'put',
    path: '/user/v1/task/{organizationId}',
    queryKeys: { required: ['user_token'] },
    bodyKeys: { required: ['action'], noRequired: ['data'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  getSyncWeworkOrgList: {
    method: 'get',
    path: '/user/v1/task/{organizationId}/list',
    queryKeys: {
      required: ['user_token'],
      noRequired: ['action'],
    },
    autoParams: { organizationId: '', user_token: '' },
    defaultParams: { action: 'SyncWeworkOrg' },
  },
  // 获取代开发应用授权二维码（授权前要求没有关联自建应用）
  getWeworkDelegateQrcode: {
    method: 'get',
    path: '/user/v1/integration/{organizationId}/wework/install-qrcode-url',
    queryKeys: { required: ['user_token'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 我已配置
  weworkAuthorized: {
    method: 'post',
    path: '/user/v1/integration/{organizationId}/wework/settings/authorized',
    queryKeys: { required: ['user_token'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 我已上线
  weworkOnline: {
    method: 'post',
    path: '/user/v1/integration/{organizationId}/wework/settings/online',
    queryKeys: { required: ['user_token'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 获取代开发应用企业信息
  getDelegateInfo: {
    method: 'get',
    path: '/user/v1/integration/{organizationId}/wework/corp-info',
    queryKeys: { required: ['user_token'] },
    autoParams: { organizationId: '', user_token: '' },
  },
};
/**
 * iDaas登录配置
 */
const idaasConfigModule: APIConfigSet = {
  // 查看玉符后台配置
  getIDaasConfig: {
    method: 'get',
    path: '/user/v1/yufu/{organizationId}/settings',
    queryKeys: { required: ['user_token'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 修改玉符后台配置
  updateIDaasConfig: {
    method: 'post',
    path: '/user/v1/yufu/{organizationId}/settings',
    queryKeys: { required: ['type', 'user_token'] },
    bodyKeys: {
      noRequired: ['tenantName', 'clientId', 'clientSecret', 'wellKnown', 'autoOrgSyncEnabled', 'serviceAccount'],
    },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 验证玉符同步配置参数
  checkIDaasConfig: {
    method: 'post',
    path: '/user/v1/yufu/{organizationId}/settings/check',
    queryKeys: { required: ['user_token', 'type'] },
    bodyKeys: {
      required: ['tenantName'],
      noRequired: ['clientId', 'clientSecret', 'wellKnown', 'autoOrgSyncEnabled', 'serviceAccount'],
    },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 解除绑定玉符账号
  removeYufuConfig: {
    method: 'post',
    path: '/user/v1/yufu/{organizationId}/settings/cancel',
    queryKeys: { required: ['type', 'user_token'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 仅测试使用，用于解绑企微和idaas的绑定
  removeAccountAssociation: {
    method: 'get',
    path: '/user/v1/yufu/{organizationId}/remove-yufu',
    queryKeys: { required: ['user_token', 'type'] },
    autoParams: { organizationId: '', user_token: '' },
  },
};
/**
 * 统一认证登录配置(ldap、windows ad、cas、oauth)
 */
const accountCofnfigModule: APIConfigSet = {
  // 设置统一身份认证配置
  setAccountProtocol: {
    method: 'post',
    path: '/user/v1/integration/{organizationId}/account-protocol/settings',
    queryKeys: { required: ['user_token'] },
    bodyKeys: {
      required: ['protocol', 'config'],
      noRequired: ['autoOrgSyncEnabled'],
    },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 获取统一身份认证配置
  getAccountProtocol: {
    method: 'get',
    path: '/user/v1/integration/{organizationId}/account-protocol/settings',
    queryKeys: { required: ['user_token'] },
    bodyKeys: {
      noRequired: ['protocol'],
    },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 删除统一身份认证配置
  removeAccountProtocol: {
    method: 'delete',
    path: '/user/v1/integration/{organizationId}/account-protocol/settings',
    queryKeys: { required: ['user_token', 'protocol'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 获取支持协议列表
  getSupportProtocolList: {
    method: 'get',
    path: '/user/v1/integration/{organizationId}/account-protocol/support-list',
    queryKeys: { required: ['user_token'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 配置测试
  testAccountProtocol: {
    method: 'post',
    path: '/user/v1/integration/{organizationId}/account-protocol/settings/check',
    queryKeys: { required: ['user_token'] },
    bodyKeys: {
      required: ['protocol', 'config'],
    },
    autoParams: { organizationId: '', user_token: '' },
  },
};

/**
 * 统计模块
 */
const statsModule: APIConfigSet = {
  // 统计已购买用户、已使用用户数量
  getUserCount: {
    method: 'get',
    path: '/user/v1/stats/{organizationId}/user-count',
    queryKeys: { required: ['user_token'] },
    autoParams: {
      organizationId: '',
      user_token: '',
    },
  },
  // 统计用户使用空间占比
  getSpaceStats: {
    method: 'get',
    path: '/user/v1/stats/{organizationId}/space-size',
    queryKeys: { required: ['user_token', 'space_tag'] },
    autoParams: {
      organizationId: '',
      user_token: '',
    },
  },
  // 团队空间存储流量详情
  getTeamUsedInfo: {
    method: 'get',
    path: '/user/v1/stats/{organizationId}/team-space-details',
    queryKeys: { required: ['user_token', 'page', 'page_size', 'keyword', 'order_by', 'order_by_type'] },
    autoParams: {
      organizationId: '',
      user_token: '',
    },
  },
  // 个人存储流量详情
  getPersonalUsedInfo: {
    method: 'get',
    path: '/user/v1/stats/{organizationId}/personal-space-details',
    queryKeys: { required: ['user_token', 'page', 'page_size', 'keyword', 'order_by', 'order_by_type'] },
    autoParams: {
      organizationId: '',
      user_token: '',
    },
  },
  // 流量统计概览
  trafficUsageOverview: {
    method: 'get',
    path: '/user/v1/stats/{organizationId}/traffic-quota',
    queryKeys: { required: ['user_token'] },
    autoParams: {
      organizationId: '',
      user_token: '',
    },
  },
  // 时序流量统计
  trafficUsageTiming: {
    method: 'post',
    path: '/user/v1/stats/{organizationId}/internet-traffic',
    queryKeys: { required: ['user_token'] },
    bodyKeys: { required: ['startTime', 'endTime'] },
    autoParams: {
      organizationId: '',
      user_token: '',
    },
  },
};

/**
 * 用户管理模块
 */
const userModule: APIConfigSet = {
  // 查询用户基本信息
  getUser: {
    method: 'get',
    path: '/user/v1/user/{organizationId}/{userId}',
    queryKeys: { required: ['user_token'], noRequired: ['with_belonging_teams', 'pf'] },
    autoParams: { organizationId: '', user_token: '', userId: '' },
    defaultParams: { with_belonging_teams: false },
  },
  // 查询用户列表
  getUserList: {
    method: 'get',
    path: '/user/v1/user/{organizationId}',
    queryKeys: {
      required: ['user_token', 'keyword', 'page', 'page_size'],
      noRequired: [
        'with_belonging_teams',
        'with_space_usage',
        'order_by',
        'order_by_type',
        'include_inactive_user',
        'show_phone_number',
      ],
    },
    autoParams: { organizationId: '', user_token: '' },
    defaultParams: { with_belonging_teams: false, with_space_usage: false },
  },
  // 查询协作用户列表
  getExtUserList: {
    method: 'get',
    path: '/user/v1/temporary/{organizationId}',
    queryKeys: {
      required: ['user_token', 'keyword', 'page', 'page_size'],
      noRequired: ['order_by', 'order_by_type', 'show_phone_number'],
    },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 新建用户
  createUser: {
    method: 'put',
    path: '/user/v1/user/{organizationId}',
    queryKeys: { required: ['user_token'] },
    autoParams: { organizationId: '', user_token: '' },
    bodyKeys: {
      required: ['nickname', 'allowPersonalSpace', 'role', 'enabled'],
      noRequired: [
        'email',
        'comment',
        'personalSpaceQuotaSize',
        'countryCode',
        'phoneNumber',
        'accountName',
        'accountPassword',
      ],
    },
  },
  // 新建协作用户
  createExtUser: {
    method: 'put',
    path: '/user/v1/temporary/{organizationId}',
    queryKeys: { required: ['user_token'] },
    autoParams: { organizationId: '', user_token: '' },
    bodyKeys: {
      required: ['countryCode', 'phoneNumber', 'nickname', 'comment', 'enabled'],
    },
  },
  // 修改用户
  updateUser: {
    method: 'post',
    path: '/user/v1/user/{organizationId}/{userId}',
    queryKeys: { required: ['user_token'] },
    autoParams: { organizationId: '', user_token: '' },
    bodyKeys: {
      noRequired: [
        'countryCode',
        'phoneNumber',
        'email',
        'nickname',
        'comment',
        'allowPersonalSpace',
        'personalSpaceQuotaSize',
        'role',
        'enabled',
      ],
    },
  },
  // 修改用户
  updateExtUser: {
    method: 'post',
    path: '/user/v1/temporary/{organizationId}/{userId}',
    queryKeys: { required: ['user_token'] },
    autoParams: { organizationId: '', user_token: '' },
    bodyKeys: {
      noRequired: ['nickname', 'comment'],
    },
  },
  // 删除用户/批量删除用户
  deleteUsers: {
    method: 'delete',
    path: '/user/v1/user/{organizationId}/{userIds}',
    queryKeys: {
      required: ['user_token'],
      noRequired: [
        'dist_user_id',
        'move_space',
        'move_share',
        'move_created_group_authorization',
        'move_join_group_authorization',
        'move_authorized',
        'move_received_authorization',
      ],
    },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 删除用户/批量删除用户
  deleteExtUsers: {
    method: 'delete',
    path: '/user/v1/temporary/{organizationId}/{userIds}',
    queryKeys: {
      required: ['user_token'],
      noRequired: ['dist_user_id'],
    },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 批量禁用/启用用户
  toggleUsersAvailable: {
    method: 'post',
    path: '/user/v1/user/{organizationId}/toggle/{userIds}',
    queryKeys: { required: ['enabled', 'user_token'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 批量禁用/启用协作用户
  toggleExtUsersAvailable: {
    method: 'post',
    path: '/user/v1/temporary/{organizationId}/toggle/{userIds}',
    queryKeys: { required: ['enabled', 'user_token'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 批量更改用户角色
  updateUsersRole: {
    method: 'post',
    path: '/user/v1/user/{organizationId}/update-role/{userIds}',
    queryKeys: { required: ['role', 'user_token'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 上传用户头像(获取头像简单上传文件参数)
  putAvatar: {
    method: 'put',
    path: '/user/v1/file/avatar',
    queryKeys: { required: ['ext', 'user_token'] },
    autoParams: { user_token: '' },
  },
  // 确认上传用户头像
  postAvatar: {
    method: 'post',
    path: '/user/v1/file/avatar/{filePath}',
    actionKey: 'for_current_org',
    queryKeys: { required: ['user_token'] },
    autoParams: { user_token: '' },
  },
  // 更新手机号-发送短信验证码
  updatePhoneSend: {
    method: 'post',
    path: '/user/v1/update-phone/send-sms-code/{countryCode}/{phoneNumber}',
    queryKeys: { required: ['user_token'] },
    autoParams: { user_token: '' },
  },
  // 确认更新手机号
  updatePhoneConfirm: {
    method: 'post',
    path: '/user/v1/update-phone/verify-sms-code/{countryCode}/{phoneNumber}/{code}',
    queryKeys: { required: ['user_token'] },
    autoParams: { user_token: '' },
  },
  // 给用户设置配额
  setUserQuota: {
    method: 'post',
    path: '/user/v1/quota/{organizationId}/personal/{userId}',
    queryKeys: { required: ['user_token'] },
    bodyKeys: { required: ['capacity'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 获取上传 xlsx 信息
  getXlsxInfo: {
    method: 'put',
    path: '/user/v1/file/allowlist/{organizationId}',
    queryKeys: { required: ['ext', 'user_token'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 检查用户 xlsx 文件
  checkXlsx: {
    method: 'post',
    path: '/user/v1/allowlist/{organizationId}/batch-import/{filePath}',
    actionKey: 'checkOnly',
    queryKeys: { required: ['user_token'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 导入 xlsx 文件
  uploadXlsx: {
    method: 'post',
    path: '/user/v1/allowlist/{organizationId}/batch-import/{filePath}',
    queryKeys: { required: ['user_token'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 查询用户所属群组
  getUserOwnerGroup: {
    method: 'get',
    path: '/user/v1/group/{organizationId}/owner-group-count/{userIds}',
    queryKeys: { required: ['user_token'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 手动激活用户
  activeUser: {
    method: 'post',
    path: '/user/v1/user/{organizationId}/activate/{userId}',
    queryKeys: { required: ['user_token'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 查询空间大小
  getUserCapacity: {
    method: 'get',
    path: '/user/v1/user/{organizationId}/stats/{userIds}',
    queryKeys: { required: ['user_token'] },
    autoParams: { organizationId: '', user_token: '' },
  },
};

/**
 * 团队管理模块
 */
const teamModule: APIConfigSet = {
  // 创建团队
  createTeam: {
    method: 'put',
    path: '/user/v1/team/{organizationId}',
    queryKeys: { required: ['user_token'] },
    bodyKeys: { required: ['name', 'defaultRoleId'], noRequired: ['parentId', 'spaceQuotaSize', 'noSpace'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 更新团队
  updateTeam: {
    method: 'post',
    path: '/user/v1/team/{organizationId}/{teamId}',
    queryKeys: { required: ['user_token'] },
    bodyKeys: { required: ['name', 'defaultRoleId'], noRequired: ['spaceQuotaSize'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 删除团队
  deleteTeam: {
    method: 'delete',
    path: '/user/v1/team/{organizationId}/{teamId}',
    queryKeys: { required: ['user_token'], noRequired: ['move_space_to_team', 'move_space_to_dir'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 查询团队列表
  queryTeam: {
    method: 'get',
    path: '/user/v1/team/{organizationId}/{teamId}',
    queryKeys: {
      required: ['user_token'],
      noRequired: [
        'with_path',
        'check_permission',
        'check_management_permission',
        'with_no_space_teams',
        'with_active_user_count',
      ],
    },
    autoParams: { organizationId: '', user_token: '' },
    defaultParams: { with_path: false, checkPermission: 1, checkManagementPermission: 0 },
  },
  // 添加团队成员
  addTeamMember: {
    method: 'put',
    path: '/user/v1/team/{organizationId}/{teamId}/user',
    queryKeys: { required: ['user_token'] },
    bodyKeys: { required: ['userIds'], noRequired: ['authorizeTo'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 查询团队成员
  queryTeamMember: {
    method: 'get',
    path: '/user/v1/team/{organizationId}/{teamId}/user',
    queryKeys: {
      required: ['page', 'page_size', 'user_token'],
      noRequired: [
        'keyword',
        'with_belonging_teams',
        'with_space_usage',
        'order_by',
        'order_by_type',
        'include_inactive_user',
        'show_phone_number',
      ],
    },
    autoParams: { organizationId: '', user_token: '' },
    defaultParams: { with_belonging_teams: false, with_space_usage: false },
  },
  // 删除团队成员
  deleteTeamMember: {
    method: 'delete',
    path: '/user/v1/team/{organizationId}/{teamId}/user',
    queryKeys: { required: ['user_token'] },
    bodyKeys: { required: ['userIds'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 修改成员权限
  editTeamMemberFileRole: {
    method: 'post',
    path: '/user/v1/team/{organizationId}/{teamId}/user/authority',
    queryKeys: { required: ['user_token'] },
    bodyKeys: { noRequired: ['authorizeTo'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 添加团队管理员
  addTeamAdmin: {
    method: 'put',
    path: '/user/v1/team/{organizationId}/{teamId}/admin/{userIds}',
    queryKeys: { required: ['user_token'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 删除团队管理员
  deleteTeamAdmin: {
    method: 'put',
    path: '/user/v1/team/{organizationId}/{teamId}/admin/{userIds}',
    actionKey: 'delete',
    queryKeys: { required: ['user_token'] },
    autoParams: { organizationId: '', user_token: '' },
  },
};

/**
 * 群组模块
 */
const collaborationModule: APIConfigSet = {
  // 创建群组
  createCollaborationSpace: {
    method: 'put',
    path: '/user/v1/group/{organizationId}',
    queryKeys: { required: ['user_token'] },
    bodyKeys: { required: ['name'], noRequired: ['allowExternalUser', 'users', 'templateIds'] },
    autoParams: { organizationId: '', user_token: '' },
    defaultParams: { allowExternalUser: false },
  },
  // 查询群组
  getCollaborationSpaceInfo: {
    method: 'get',
    path: '/user/v1/group/{organizationId}/{groupId}',
    queryKeys: { required: ['user_token', 'space_org_id'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 列出用户所在群组
  listCollaborationSpaces: {
    method: 'get',
    path: '/user/v1/group/{organizationId}/list',
    queryKeys: {
      required: ['user_token'],
      noRequired: [
        'with_directory',
        'with_file_count',
        'check_update_recursively',
        'page',
        'page_size',
        'admin_only',
        'join_type',
        'join_time_start',
        'join_time_end',
        'with_users',
      ],
    },
    autoParams: { organizationId: '', user_token: '' },
    defaultParams: {
      page: 1,
      page_size: 20,
      with_directory: 0,
      with_file_count: 0,
      check_update_recursively: 0,
      join_type: 'all',
      with_users: 1,
    },
  },
  // 更新群组
  updateCollaborationSpace: {
    method: 'post',
    path: '/user/v1/group/{organizationId}/{groupId}',
    queryKeys: { required: ['user_token'] },
    bodyKeys: { required: ['name'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 删除群组
  deleteCollaborationSpace: {
    method: 'delete',
    path: '/user/v1/group/{organizationId}/{groupId}',
    queryKeys: { required: ['user_token'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 添加群组成员
  addCollaborationSpaceMembers: {
    method: 'put',
    path: '/user/v1/group/{organizationId}/{groupId}/user',
    queryKeys: { required: ['user_token'] },
    bodyKeys: { required: ['users'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 修改群组成员角色/权限
  updateCollaborationSpaceMembers: {
    method: 'post',
    path: '/user/v1/group/{organizationId}/{groupId}/user',
    queryKeys: { required: ['user_token'] },
    bodyKeys: { required: ['users'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 查询群组成员
  getCollaborationSpaceMembers: {
    method: 'get',
    path: '/user/v1/group/{organizationId}/{groupId}/user',
    queryKeys: {
      required: ['user_token'],
      noRequired: ['keyword', 'order_by', 'order_by_type', 'page', 'page_size', 'space_org_id'],
    },
    autoParams: { organizationId: '', user_token: '' },
    defaultParams: {
      page: 1,
      page_size: 20,
      order_by: 'groupRole',
    },
  },
  // 删除群组成员
  deleteCollaborationSpaceMember: {
    method: 'post',
    path: '/user/v1/group/{organizationId}/{groupId}/delete-user',
    queryKeys: { required: ['user_token'] },
    bodyKeys: { required: ['users'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 退出群组（非群主）
  exitCollaborationSpace: {
    method: 'post',
    path: '/user/v1/group/{organizationId}/{groupId}/exit',
    queryKeys: { required: ['user_token'] },
    bodyKeys: { required: ['users'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 列出群组空间
  getGroupSpace: {
    method: 'get',
    path: '/user/v1/space/{organizationId}/group/{groupId}',
    queryKeys: { required: ['user_token', 'space_org_id'] },
    autoParams: {
      organizationId: '',
      user_token: '',
    },
  },
};

/*
 * 收藏模块
 */
const favoriteModule: APIConfigSet = {
  // 查看收藏列表
  getFavoriteList: {
    method: 'get',
    path: '/user/v1/favorite/{organizationId}',
    queryKeys: {
      required: ['page', 'page_size', 'user_token'],
      noRequired: ['favorite_group_id', 'order_by', 'order_by_type'],
    },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 添加收藏（收藏文件目录）
  addFavorite: {
    method: 'put',
    path: '/user/v1/favorite/{organizationId}',
    queryKeys: { required: ['user_token'] },
    bodyKeys: { required: ['spaceId', 'path', 'spaceOrgId'], noRequired: ['favoriteGroupId'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 取消收藏（删除收藏）
  delFavorite: {
    method: 'delete',
    path: '/user/v1/favorite/{organizationId}/{favoriteIds}',
    queryKeys: { required: ['user_token'], noRequired: ['space_org_id'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 获取文件额外信息接口
  getFileExtraInfo: {
    method: 'post',
    path: '/user/v1/directory/{organizationId}/list/extra-info',
    queryKeys: { required: ['user_token'] },
    bodyKeys: 'custom',
    autoParams: { organizationId: '', user_token: '' },
  },
  // 获取图片预览图
  getImageThumbnail: {
    method: 'post',
    path: '/user/v1/directory/{organizationId}/thumbnail',
    queryKeys: { required: ['user_token', 'size'] },
    bodyKeys: { required: ['directoryInfoList'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // TODO: （API 文档中新增，目前未使用）创建收藏夹
  createFacoriteGroup: {
    method: 'put',
    path: '/user/v1/favorite-group/{organizationId}',
    queryKeys: { required: ['user_token'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // TODO: （API 文档中新增，目前未使用）列出收藏夹
  getFacoriteGroups: {
    method: 'get',
    path: '/user/v1/favorite-group/{organizationId}',
    queryKeys: { required: ['user_token'], noRequired: ['tag'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // TODO: （API 文档中新增，目前未使用）更新收藏夹
  updateFacoriteGroup: {
    method: 'post',
    path: '/user/v1/favorite-group/{organizationId}',
    queryKeys: { required: ['user_token'], noRequired: ['tag'] },
    bodyKeys: { required: ['name', 'tag'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // TODO: （API 文档中新增，目前未使用）删除收藏夹
  deleteFacoriteGroup: {
    method: 'delete',
    path: '/user/v1/favorite-group/{organizationId}/{favoriteGroupId}',
    queryKeys: { required: ['user_token'] },
    autoParams: { organizationId: '', user_token: '' },
  },
};

/**
 * 团队搜索模块
 */
const teamSearchModule: APIConfigSet = {
  // 创建搜索团队任务
  createSearchTeamTask: {
    method: 'post',
    path: '/user/v1/search/{organizationId}/team',
    queryKeys: {
      required: ['check_children', 'user_token'],
      noRequired: ['check_management_permission', 'check_belonging_teams', 'with_no_space_teams'],
    },
    bodyKeys: { required: ['keyword'], noRequired: ['ancestorId'] },
    autoParams: { organizationId: '', user_token: '' },
    defaultParams: { check_children: false, checkManagementPermission: 0 },
  },
  // 继续列出搜索团队任务
  listSearchTeamContent: {
    method: 'get',
    path: '/user/v1/search/{organizationId}/team/{searchId}',
    queryKeys: { required: ['check_children', 'user_token', 'marker'], noRequired: ['with_no_space_teams'] },
    autoParams: { organizationId: '', user_token: '' },
    defaultParams: { check_children: false },
  },
  // 删除搜索任务
  deleteSearchTeamTask: {
    method: 'delete',
    path: '/user/v1/search/{organizationId}/{searchId}',
    queryKeys: { required: ['user_token'] },
    autoParams: { organizationId: '', user_token: '' },
  },
};

/**
 * 日志搜索模块
 */
const logSearchModule: APIConfigSet = {
  // 创建下载日志任务
  createDownloadLogTask: {
    method: 'put',
    path: '/user/v1/task/{organizationId}',
    queryKeys: { required: ['user_token'] },
    bodyKeys: { required: ['data'], noRequired: ['action'] },
    autoParams: { organizationId: '', user_token: '' },
    defaultParams: { action: 'DownloadLog' },
  },
  // 查询下载日志任务
  listDownloadLogTask: {
    method: 'get',
    path: '/user/v1/task/{organizationId}/list',
    queryKeys: { required: ['user_token'], noRequired: ['action'] },
    autoParams: { organizationId: '', user_token: '' },
    defaultParams: { action: 'DownloadLog' },
  },
  // 创建搜索任务
  createSearchLogTask: {
    method: 'post',
    path: '/user/v1/search/{organizationId}/log',
    queryKeys: { required: ['user_token'] },
    bodyKeys: {
      noRequired: ['keyword', 'actionType', 'startTime', 'endTime', 'operator', 'spaceTag', 'teamId', 'searchAfter'],
    },
    autoParams: { organizationId: '', user_token: '' },
    defaultParams: { spaceTag: 'all' },
  },
  // 继续列出搜索日志
  listSearchLog: {
    method: 'get',
    path: '/user/v1/search/{organizationId}/log/{searchId}',
    queryKeys: { required: ['marker', 'user_token'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 删除搜索任务
  delSearchInLog: {
    method: 'delete',
    path: '/user/v1/search/{organizationId}/{searchId}',
    queryKeys: { required: ['user_token'] },
    autoParams: { organizationId: '', user_token: '' },
  },
};

/**
 * 历史版本接口
 */
const historyVersionModule: APIConfigSet = {
  // 查看历史版本列表
  getHistoryList: {
    method: 'get',
    path: '/user/v1/history/{organizationId}/{spaceId}/history-list/{dirPath}',
    queryKeys: {
      required: ['page', 'user_token', 'space_org_id'],
      noRequired: ['page_size', 'order_by', 'order_by_type'],
    },
    autoParams: { organizationId: '', spaceId: '', user_token: '' },
  },
  // 获取组织历史版本参数
  getLibraryHistoryExtension: {
    method: 'get',
    path: '/user/v1/organization/{organizationId}/history-settings',
    queryKeys: { required: ['user_token'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 修改组织历史版本参数
  setVersionConfig: {
    method: 'post',
    path: '/user/v1/organization/{organizationId}/history-settings',
    queryKeys: { required: ['user_token'] },
    bodyKeys: {
      required: ['enableFileHistory'],
      noRequired: ['isClearFileHistory', 'fileHistoryCount', 'fileHistoryExpireDay'],
    },
    autoParams: { organizationId: '', user_token: '' },
  },
};

/**
 * 安全扫描接口
 */
const securityScanModule: APIConfigSet = {
  // 获取安全扫描配置
  getSecurityScanConfig: {
    method: 'get',
    path: '/user/v1/virus-detection/{organizationId}/settings',
    queryKeys: { required: ['user_token'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 修改安全扫描配置
  setSecurityScanConfig: {
    method: 'put',
    path: '/user/v1/virus-detection/{organizationId}/settings',
    queryKeys: { required: ['user_token'] },
    bodyKeys: { required: ['enableAntivirus'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 防勒索通知
  ransomwareWarn: {
    method: 'post',
    path: '/user/v1/virus-detection/{organizationId}/ransomware-warn',
    queryKeys: { required: ['user_token'] },
    bodyKeys: { required: ['equipment', 'deviceType'] },
    autoParams: { organizationId: '', user_token: '' },
  },
};

/**
 * 腾讯会议相关接口
 */
const meetingModule: APIConfigSet = {
  // 检查腾讯会议授权是否有效
  checkMeetingAuth: {
    method: 'get',
    path: '/user/v1/meeting/{organizationId}/check-auth',
    queryKeys: { required: ['user_token'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 腾讯会议授权
  authMeeting: {
    method: 'get',
    path: '/user/v1/meeting/{organizationId}/auth',
    queryKeys: { required: ['user_token', 'auth_code'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 根据会议 code 获取加入链接
  joinMeetingByCode: {
    method: 'get',
    path: '/user/v1/meeting/{organizationId}',
    actionKey: 'info',
    queryKeys: { required: ['meeting_code', 'user_token'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 创建会议
  createMeeting: {
    method: 'post',
    path: '/user/v1/meeting/{organizationId}',
    queryKeys: { required: ['user_token'] },
    bodyKeys: { required: ['meetingConfig'], noRequired: ['meetingRecordConfig'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 获取当前用户即将开始的会议
  getMeetingLists: {
    method: 'get',
    path: '/user/v1/meeting/{organizationId}/list',
    queryKeys: { required: ['user_token'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 解绑腾讯会议
  deleteMeetingAuth: {
    method: 'delete',
    path: '/user/v1/meeting/{organizationId}/auth',
    queryKeys: { required: ['user_token'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 获取会议签名 用于sdk授权
  getMeetingSign: {
    method: 'get',
    path: '/user/v1/meeting/js-sign',
    queryKeys: { required: ['code', 'url'] },
  },
};

/**
 * 新手引导相关接口
 */
const noviceGuidanceModule: APIConfigSet = {
  // 查询新手引导数据
  queryNoviceGuidance: {
    method: 'get',
    path: '/user/v1/store/{organizationId}/novice-guidance',
    queryKeys: { required: ['user_token'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 生成新手指引数据
  createNoviceGuidance: {
    method: 'put',
    path: '/user/v1/store/{organizationId}/novice-guidance',
    queryKeys: { required: ['user_token'] },
    bodyKeys: {
      noRequired: [
        'guideFinishedShow',
        'advanceGuideFinished',
        'baseGuide',
        'didAdmin',
        'collaborationSpaceGuides',
        'searchGuideFinished',
        'workbenchTools',
      ],
    },
    autoParams: { organizationId: '', user_token: '' },
  },
};
/*
 * 协作模块
 */
const coModule: APIConfigSet = {
  // 查询加入企业/群组的邀请码信息(未登录用户)
  getInvitationInfo: {
    method: 'get',
    path: '/user/v1/invite/{code}',
  },
  // 查询加入企业/群组的邀请码信息(已登录用户)
  getInvitationInfoWithUserInfo: {
    method: 'get',
    path: '/user/v1/invite/{organizationId}/{code}',
    queryKeys: { required: ['user_token'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 加入群组
  joinGroup: {
    method: 'post',
    path: '/user/v1/invite/{organizationId}/{code}/join-group',
    queryKeys: { required: ['user_token'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 加入企业
  joinOrg: {
    method: 'post',
    path: '/user/v1/invite/{organizationId}/{code}/join-org',
    queryKeys: { required: ['user_token'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  joinTemporary: {
    method: 'post',
    path: '/user/v1/invite/{organizationId}/{code}/join-temporary',
    queryKeys: { required: ['user_token'] },
    autoParams: { organizationId: '', user_token: '' },
  },
};

/*
 * 其它模块
 */
const othersModule: APIConfigSet = {
  // 查看文件或目录详情
  getDirectoryOrFileInfo: {
    method: 'get',
    path: '/user/v1/directory/{organizationId}/{spaceId}/{path}',
    actionKey: 'info',
    queryKeys: { required: ['user_token', 'space_org_id'], noRequired: ['syncId'] },
    autoParams: { organizationId: '', spaceId: '', user_token: '' },
    defaultParams: { path: '' },
  },
  // 列出接收的共享文件（获取共享给我的文件夹）
  getReceiveShareDirectory: {
    method: 'get',
    path: '/user/v1/authority/{organizationId}/received-authorization-directory',
    queryKeys: { required: ['user_token', 'page', 'page_size'], noRequired: ['order_by', 'order_by_type'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 列出与我相关的文件
  getRelatedToMeDirectory: {
    method: 'get',
    path: '/user/v1/directory/{organizationId}/related-to-me',
    queryKeys: { required: ['user_token', 'page', 'page_size'], noRequired: ['order_by', 'order_by_type'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 获取最近使用文件列表
  getRecentlyUsedDirectory: {
    method: 'get',
    path: '/user/v1/directory/{organizationId}/recently-used',
    queryKeys: { required: ['user_token', 'page', 'page_size'], noRequired: ['order_by', 'order_by_type'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 共享授权-查看文件权限（查看文件共享权限列表）
  getDirPermissions: {
    method: 'get',
    path: '/user/v1/authority/{organizationId}/directory-authority/{dirPath}',
    queryKeys: {
      required: [{ dirLibraryId: 'libraryId' }, { dirSpaceId: 'spaceId' }, { user_token: 'userToken' }],
      noRequired: ['space_org_id', 'version', 'limit', 'marker', 'keyword'],
    },
    autoParams: { organizationId: '', access_token: '', libraryId: '', spaceId: '', userToken: '' },
  },
  // 查询异步任务 （只能查询 user.api 接口创建的异步任务）
  queryTask: {
    method: 'get',
    path: '/user/v1/task/{organizationId}/{taskIdList}',
    queryKeys: { required: ['user_token'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 取消异步任务
  cancelTask: {
    method: 'post',
    path: '/user/v1/task/{organizationId}/cancel/{taskId}',
    queryKeys: { required: ['user_token'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 删除任务
  deleteTask: {
    method: 'delete',
    path: '/user/v1/task/{organizationId}/{taskId}',
    queryKeys: { required: ['user_token'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 解绑微信
  deleteWechatAuth: {
    method: 'delete',
    path: '/user/v1/wechat/{organizationId}/auth',
    queryKeys: { required: ['user_token'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 解绑yufu
  deleteYufuAuth: {
    method: 'delete',
    path: '/user/v1/yufu/{organizationId}/auth',
    queryKeys: { required: ['user_token'] },
    autoParams: { organizationId: '', user_token: '' },
  },
};

/**
 * 邀请加入企业
 */
const inviteModule: APIConfigSet = {
  // 生成加入企业邀请码
  generateInviteCode: {
    method: 'put',
    path: '/user/v1/invite/{organizationId}/invite-to-org',
    queryKeys: { required: ['user_token'] },
    bodyKeys: { required: ['role'], noRequired: ['allowPersonalSpace', 'personalSpaceQuotaSize'] },
    autoParams: { organizationId: '', user_token: '' },
    defaultParams: { role: 'user' },
  },
  // 生成临时用户加入企业邀请码
  generateExtInviteCode: {
    method: 'put',
    path: '/user/v1/invite/{organizationId}/invite-to-temporary',
    queryKeys: { required: ['user_token'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 查询加入企业邀请码的信息
  getInviteCode: {
    method: 'get',
    path: '/user/v1/invite/{organizationId}/invite-to-org',
    queryKeys: { required: ['user_token'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 查询临时用户加入企业邀请码的信息
  getExtInviteCode: {
    method: 'get',
    path: '/user/v1/invite/{organizationId}/invite-to-temporary',
    queryKeys: { required: ['user_token'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 查询邀请码的信息
  getInviteCodeInfo: {
    method: 'get',
    path: '/user/v1/invite/{code}',
    queryKeys: { noRequired: ['user_token'] },
    autoParams: { user_token: '' },
  },
  // 生成加入群组邀请码
  generateGroupInviteCode: {
    method: 'put',
    path: '/user/v1/invite/{organizationId}/invite-to-group',
    queryKeys: { required: ['user_token'] },
    bodyKeys: { required: ['groupId', 'authRoleId'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 查询群组邀请码
  getGroupInviteCode: {
    method: 'get',
    path: '/user/v1/invite/{organizationId}/invite-to-group/{groupId}',
    queryKeys: { required: ['user_token'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 查询加入群组邀请码的信息
  getGroupInviteInfo: {
    method: 'get',
    path: '/user/v1/invite/{code}',
    queryKeys: { noRequired: ['user_token'] },
    autoParams: { user_token: '' },
  },
  // 更新加入群组邀请码的信息
  updateInviteCode: {
    method: 'post',
    path: '/user/v1/invite/{organizationId}/edit/{code}',
    queryKeys: { required: ['user_token'] },
    bodyKeys: {
      noRequired: [
        'enabled',
        'groupId',
        'authRoleId',
        'allowExternalUser',
        'expireTime',
        'allowPersonalSpace',
        'personalSpaceQuotaSize',
      ],
    },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 删除群组或企业邀请码code
  deleteInviteCode: {
    method: 'delete',
    path: '/user/v1/invite/{organizationId}/{code}',
    queryKeys: { required: ['user_token'] },
    autoParams: { organizationId: '', user_token: '' },
  },
};

/**
 * 米大师支付接口
 */
const midasPayModule: APIConfigSet = {
  midasPurchase: {
    method: 'put',
    path: '/user/v1/purchase/{organizationId}',
    queryKeys: { required: ['user_token'] },
    bodyKeys: { required: ['isNew', 'productid'], noRequired: ['extensionData'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  midasGetPurchaseId: {
    method: 'get',
    path: '/user/v1/purchase/{purchaseId}',
    queryKeys: { required: ['purchaseId', 'user_token'] },
    autoParams: { purchaseId: '', user_token: '' },
  },
};

/**
 * 注册、注销相关接口
 */
const deregisterModule: APIConfigSet = {
  // 检查是否可以注销账号
  checkDeregister: {
    method: 'get',
    path: '/user/v1/deregister/{organizationId}/check',
    queryKeys: { required: ['user_token'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 发起注销
  deregister: {
    method: 'post',
    path: '/user/v1/deregister/{organizationId}',
    queryKeys: { required: ['user_token'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 用户自己取消注销
  cancelDeregister: {
    method: 'post',
    path: '/user/v1/deregister/{organizationId}/cancel',
    queryKeys: { required: ['user_token'] },
    autoParams: { user_token: '' },
  },
  // 管理员驳回注销
  rejectDeregister: {
    method: 'post',
    path: '/user/v1/deregister/{organizationId}/cancel/{userId}',
    queryKeys: { required: ['user_token'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 恢复个人版
  restorePersonalAccount: {
    method: 'post',
    path: '/user/v1/register/personal-organization',
    queryKeys: { required: ['user_token'] },
    autoParams: { user_token: '' },
  },
  // 创建渠道体验版【只在渠道内有效，比如腾讯会议内】
  createChannelOrg: {
    method: 'post',
    path: '/user/v1/channel/create',
    queryKeys: { required: ['user_token'], noRequired: ['pf'] },
    autoParams: { user_token: '' },
  },
};

/**
 * 电子签相关接口
 */
const electronicSignModule: APIConfigSet = {
  // 查询电子签可用模板列表
  getElectronicSignTemplates: {
    method: 'get',
    path: '/user/v1/e-sign/{organizationId}/template',
    queryKeys: { required: ['user_token'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  /**
   * 场景：在打开电子签二维码的时候，需要提前获取 电子签流程 key
   * key
   */
  // 生成电子签二维码 key
  getElectronSignKey: {
    method: 'put',
    path: '/user/v1/e-sign/{organizationId}',
    queryKeys: { required: ['user_token'] },
    bodyKeys: {
      required: [
        'distDirectoryPath',
        'distSpaceId',
        'distLibraryId',
        'originalPath',
        'originalSpaceId',
        'originalLibraryId',
      ],
    },
    autoParams: { user_token: '', organizationId: '' },
  },
  /**
   * 根据key获取对应的流程状态
   * ["new" | "scanned" | "needToConfirm" | "confirmed"|"codeReturned"|"finished"]
   * [0,1,2,3,4,5]
   * 场景： 在打开电子签名弹窗的时候，需要ws或者轮询来获取对应的状态
   */
  getElectronSignStatus: {
    method: 'get',
    path: '/user/v1/e-sign/{organizationId}/{key}/status',
    queryKeys: { required: ['user_token'] },
    autoParams: { user_token: '', organizationId: '', key: '' },
  },
  // 手动确认授权 Key
  confirmElectronSignKey: {
    method: 'post',
    path: '/user/v1/e-sign/{organizationId}/confirm',
    queryKeys: { required: ['user_token'] },
    bodyKeys: { required: ['key'] },
    autoParams: { user_token: '', organizationId: '', key: '' },
  },
};

/**
 * 安全相关接口
 */
const cloudHerbsModule: APIConfigSet = {
  // 查询可疑文件列表
  getCloudHerbsList: {
    method: 'post',
    path: '/user/v1/virus-detection/{organizationId}/list',
    queryKeys: {
      required: ['user_token'],
      noRequired: ['order_by', 'order_by_type', 'limit', 'marker', 'filter_type', 'created_by'],
    },
    bodyKeys: { noRequired: ['spaceItems'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 查询敏感词的列表
  getSensitiveList: {
    method: 'get',
    path: '/user/v1/sensitive-word/{organizationId}/list',
    queryKeys: {
      required: ['user_token'],
    },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 查询敏感词统计列表
  getSensitiveCountList: {
    method: 'get',
    path: '/user/v1/sensitive-word/{organizationId}/statis-list',
    queryKeys: {
      required: ['user_token'],
    },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 根据敏感词查询匹配到的文件列表
  getSensitiveWordList: {
    method: 'get',
    path: '/user/v1/sensitive-word/{organizationId}/sensitive-directory-list',
    queryKeys: {
      required: ['user_token', 'word'],
    },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 信任病毒文件
  trustVirusFile: {
    method: 'post',
    path: '/user/v1/virus-detection/{organizationId}/restore',
    queryKeys: { required: ['user_token'] },
    bodyKeys: { noRequired: ['restoreItems'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 信任敏感文件
  trustSensitiveFile: {
    method: 'post',
    path: '/user/v1/sensitive-word/{organizationId}/directory-trust',
    queryKeys: { required: ['user_token'] },
    bodyKeys: { required: ['directoryList'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 创建敏感词
  createSensitiveWord: {
    method: 'post',
    path: '/user/v1/sensitive-word/{organizationId}',
    queryKeys: { required: ['user_token'] },
    bodyKeys: { required: ['words'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  deleteSensitiveWord: {
    method: 'post',
    path: '/user/v1/sensitive-word/{organizationId}/',
    queryKeys: { required: ['user_token'] },
    actionKey: 'delete',
    bodyKeys: { required: ['words'] },
    autoParams: { organizationId: '', user_token: '' },
  },
};

/**
 * oauth2相关接口
 */
const oauthModule: APIConfigSet = {
  // 获取应用授权code
  getOauthCode: {
    method: 'post',
    path: '/user/v1/oauth2/{organizationId}/authorize',
    queryKeys: {
      required: ['user_token', 'app_id', 'redirect_uri', 'response_type'],
      noRequired: ['scope', 'state', 'auto_redirect'],
    },
    bodyKeys: { required: ['directoryScopes'] },
    autoParams: { user_token: '', response_type: 'code' },
  },
  // 动态获取oauth2授权的文案
  getOauthInfo: {
    method: 'get',
    path: '/user/v1/oauth2/authorize-scopes',
    queryKeys: { required: ['app_id'] },
  },
};

const ipRestrictionModule: APIConfigSet = {
  // 查看ip限制列表，需要管理员权限
  getIPRestrictionList: {
    method: 'get',
    path: '/user/v1/ip-rule/{organizationId}/list',
    queryKeys: { required: ['user_token'], noRequired: ['page', 'pageSize'] },
    autoParams: { user_token: '', organizationId: '' },
  },
  // 查看IP管理员限制状态
  getIPAdminStatus: {
    method: 'get',
    path: '/user/v1/ip-rule/{organizationId}/settings',
    queryKeys: { required: ['user_token'] },
    autoParams: { user_token: '', organizationId: '' },
  },
  // 新增ip限制后台配置，修改ip限制操作，需要管理员权限
  addIPRestriction: {
    method: 'put',
    path: '/user/v1/ip-rule/{organizationId}',
    queryKeys: { required: ['user_token'] },
    bodyKeys: 'custom',
    autoParams: { user_token: '', organizationId: '' },
  },
  // 修改ip限制操作，需要管理员权限
  editIPRestriction: {
    method: 'post',
    actionKey: 'update',
    path: '/user/v1/ip-rule/{organizationId}/{id}',
    queryKeys: { required: ['user_token'] },
    bodyKeys: { noRequired: ['startIp', 'endIp', 'enabled'] },
    autoParams: { user_token: '', organizationId: '' },
  },
  deleteIPRestriction: {
    method: 'delete',
    path: '/user/v1/ip-rule/{organizationId}/{id}',
    queryKeys: { required: ['user_token'] },
    autoParams: { user_token: '', organizationId: '' },
  },
  modifyIPAdminStatus: {
    method: 'post',
    path: '/user/v1/ip-rule/{organizationId}/settings',
    queryKeys: { required: ['user_token'] },
    bodyKeys: { noRequired: ['limitAdmin'] },
    autoParams: { user_token: '', organizationId: '' },
  },
};

/**
 * 文件收集模块
 */
const fileCollectModule: APIConfigSet = {
  // 发起文件收集
  launchedFileCollection: {
    method: 'put',
    path: '/user/v1/collect/{organizationId}',
    queryKeys: { required: ['user_token'] },
    autoParams: { user_token: '', organizationId: '' },
    bodyKeys: {
      required: [
        'title',
        'describes',
        'path',
        'expireTime',
        'allowedUsers',
        'exampleFiles',
        'namingRules',
        'fileType',
        'spaceId',
        'spaceOrgId',
        'isPermanent',
      ],
      // noRequired: ['spaceId'],
    },
  },
  // 我发起的文件收集列表
  getLaunchedFileCollectionList: {
    method: 'get',
    path: '/user/v1/collect/{organizationId}/launched/list',
    queryKeys: { required: ['user_token', 'page', 'page_size'], noRequired: ['order_by', 'order_by_type'] },
    autoParams: { user_token: '', organizationId: '' },
  },
  // 我收到的文件收集列表
  getReceivedFileCollectionList: {
    method: 'get',
    path: '/user/v1/collect/{organizationId}/received/list',
    queryKeys: { required: ['user_token', 'page', 'page_size'], noRequired: ['order_by', 'order_by_type'] },
    autoParams: { user_token: '', organizationId: '' },
  },
  // 我发起的文件收集设置查看
  getLaunchedFileCollectionSetting: {
    method: 'get',
    path: '/user/v1/collect/{organizationId}/launched/{collectId}',
    queryKeys: { required: ['user_token'] },
    autoParams: { user_token: '', collectId: '', organizationId: '' },
  },
  // 我发起的收集设置修改
  updateLaunchedFileCollectionSetting: {
    method: 'post',
    path: '/user/v1/collect/{organizationId}/launched/{collectId}',
    queryKeys: { required: ['user_token'] },
    autoParams: { user_token: '', collectId: '', organizationId: '' },
    bodyKeys: {
      required: [
        'title',
        'describes',
        'path',
        'expireTime',
        'allowedUsers',
        'exampleFiles',
        'namingRules',
        'fileType',
        'spaceId',
        'spaceOrgId',
        'collectId',
        'isPermanent',
      ],
    },
  },
  // 文件提交状态查看
  getFileSubmitStatus: {
    method: 'get',
    path: '/user/v1/collect/{organizationId}/state/{collectId}',
    queryKeys: { required: ['user_token'] },
    autoParams: { user_token: '', collectId: '', organizationId: '' },
  },
  // 停止收集
  stopFileCollection: {
    method: 'post',
    path: '/user/v1/collect/{organizationId}/pause/{collectId}',
    queryKeys: { required: ['user_token'] },
    autoParams: { user_token: '', organizationId: '' },
    bodyKeys: { required: ['collectId'] },
  },
  // 重新开始文件收集
  restartFileCollection: {
    method: 'post',
    path: '/user/v1/collect/{organizationId}/restart/{collectId}',
    queryKeys: { required: ['user_token'] },
    autoParams: { user_token: '', organizationId: '' },
    bodyKeys: { required: ['collectId'] },
  },
  // 任务删除
  deleteFileCollection: {
    method: 'delete',
    path: '/user/v1/collect/{organizationId}/{collectId}',
    queryKeys: { required: ['user_token'] },
    autoParams: { user_token: '', collectId: '', organizationId: '' },
  },
  // 获取单个文件收集任务
  getCollectTask: {
    method: 'get',
    path: '/user/v1/collect/visit/{collectToken}',
  },
  getCollectHistory: {
    method: 'get',
    path: '/user/v1/collect/{organizationId}/submit-history/{collectId}?user_token={userToken}',
    autoParams: { organizationId: '', user_token: '' },
  },
  // 外部用户的Token获取
  getCollectAccessToken: {
    method: 'post',
    path: '/user/v1/collect/access/{collectToken}?user_token={userToken}',
    queryKeys: { required: ['collectToken'] },
  },
  // 内部用户的Token获取
  getCollectAccessTokenInner: {
    method: 'post',
    path: '/user/v1/collect/{organizationId}/access/{collectToken}',
    queryKeys: { required: ['collectToken', 'user_token'] },
    autoParams: { user_token: '', organizationId: '' },
  },
  getCollectStatus: {
    method: 'get',
    path: '/user/v1/collect/{organizationId}/state/{collectId}?user_token={userToken}',
    queryKeys: { required: ['collectId'] },
    autoParams: { user_token: '', organizationId: '' },
  },
};

/**
 * 文件审批模块
 */
const fileApplyModule: APIConfigSet = {
  addFileApply: {
    method: 'put',
    path: '/user/v1/authority/{organizationId}/apply-directory-authority',
    queryKeys: { required: ['user_token'] },
    bodyKeys: {
      required: ['spaceId', 'pathList', 'title', 'reason', 'roleId'],
    },
    autoParams: { user_token: '', organizationId: '' },
  },
  agreeFileApply: {
    method: 'post',
    path: '/user/v1/authority/{organizationId}/apply/{applyNo}?agree',
    queryKeys: { required: ['user_token'] },
    autoParams: { applyNo: '', user_token: '', organizationId: '' },
  },
  getFileApplyList: {
    method: 'get',
    path: '/user/v1/authority/{organizationId}/apply/list',
    queryKeys: {
      noRequired: ['type', 'orderBy', 'orderByType', 'user_token', 'page', 'pageSize', 'marker', 'limit', 'status'],
    },
    autoParams: { user_token: '', organizationId: '' },
  },
  cancelFileApply: {
    method: 'post',
    path: '/user/v1/authority/{organizationId}/apply/{applyNo}?cancel',
    queryKeys: { required: ['user_token'] },
    autoParams: { applyNo: '', user_token: '', organizationId: '' },
  },
  getFileApply: {
    method: 'get',
    path: '/user/v1/authority/{organizationId}/apply/detail/{applyNo}',
    queryKeys: { required: ['user_token'] },
    autoParams: { applyNo: '', user_token: '', organizationId: '' },
  },
  checkFileApply: {
    method: 'post',
    path: '/user/v1/authority/{organizationId}/check-directory-apply',
    queryKeys: { required: ['user_token'] },
    bodyKeys: {
      required: ['spaceId', 'pathList'],
    },
    autoParams: { user_token: '', organizationId: '' },
  },
  rejectFileApply: {
    method: 'post',
    path: '/user/v1/authority/{organizationId}/apply/{applyNo}?disagree',
    queryKeys: { required: ['user_token'] },
    autoParams: { applyNo: '', user_token: '', organizationId: '' },
  },
};

/**
 * 账密模块
 */
const passwordModule: APIConfigSet = {
  // 自己修改密码
  updatePassword: {
    method: 'post',
    path: '/user/v1/user-login/{organizationId}/account-password',
    queryKeys: { required: ['user_token'] },
    bodyKeys: {
      required: ['originalAccountPassword', 'accountPassword'],
    },
    autoParams: { user_token: '', organizationId: '' },
  },
  // 超管修改账号
  updateAccountName: {
    method: 'post',
    path: '/user/v1/user-login/{organizationId}/account-name',
    queryKeys: { required: ['user_token'] },
    bodyKeys: {
      required: ['originalAccountName', 'newAccountName'],
    },
    autoParams: { user_token: '', organizationId: '' },
  },
  // 生成重置密码token
  createResetToken: {
    method: 'post',
    path: '/user/v1/user-login/{organizationId}/reset-password-token',
    queryKeys: { required: ['user_token'] },
    bodyKeys: { required: ['userId'] },
    autoParams: { user_token: '', organizationId: '' },
  },
  // 查询用户是否有重置token
  getResetToken: {
    method: 'get',
    path: '/user/v1/user-login/{organizationId}/reset-password-token',
    queryKeys: { required: ['resetUserId', 'user_token'] },
    autoParams: { user_token: '', organizationId: '' },
  },
  // 查询token详情
  getResetTokenDetail: {
    method: 'get',
    path: '/user/v1/user-login/reset-url-detail',
    queryKeys: { required: ['user_token', 'reset_password_token'] },
    autoParams: { user_token: '' },
  },
  // 使用token重置新密码
  resetNewPassword: {
    method: 'post',
    path: '/user/v1/user-login/reset-password',
    queryKeys: { required: ['user_token'] },
    bodyKeys: { required: ['accountName', 'accountPassword', 'resetToken'] },
    autoParams: { user_token: '' },
  },
};

/**
 * 文件同步操作接口
 */
const fileSyncOperateModule: APIConfigSet = {
  // 创建同步任务
  createSync: {
    method: 'put',
    path: '/user/v1/sync/{organizationId}',
    queryKeys: { required: ['user_token'] },
    bodyKeys: { required: ['cloudPath', 'mode', 'localPath', 'clientId', 'spaceTag'], noRequired: ['teamId'] },
    autoParams: { organizationId: '', user_token: '', spaceTag: 'personal' },
  },
  // 删除同步任务
  deleteSync: {
    method: 'delete',
    path: '/user/v1/sync/{organizationId}/{syncId}',
    queryKeys: { required: ['user_token'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 修改同步任务
  modifySyncInfo: {
    method: 'post',
    path: '/user/v1/sync/{organizationId}/{syncId}',
    queryKeys: { required: ['user_token'] },
    bodyKeys: { noRequired: ['localPath', 'clientId'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 查询全部同步任务
  getSyncsInfo: {
    method: 'get',
    path: '/user/v1/sync/{organizationId}',
    queryKeys: { required: ['user_token', 'client_id', 'marker', 'limit'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 查询单个同步任务
  getSyncInfo: {
    method: 'get',
    path: '/user/v1/sync/{organizationId}/{syncId}',
    queryKeys: { required: ['user_token'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  querySyncInfo: {
    method: 'get',
    path: '/user/v1/sync/{organizationId}',
    queryKeys: { required: ['user_token', 'id_list'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 查询同步盘默认参数（默认排除清单），按 orgId 维度
  getSyncDefaultRule: {
    method: 'get',
    path: '/user/v1/sync/{organizationId}/default-rule',
    queryKeys: { required: ['user_token'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 创建/更新同步盘默认参数（upsert，超管/系统管理员）
  putSyncDefaultRule: {
    method: 'put',
    path: '/user/v1/sync/{organizationId}/default-rule',
    queryKeys: { required: ['user_token'] },
    bodyKeys: { required: ['ignoreList'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  // 删除同步盘默认参数（超管/系统管理员）
  deleteSyncDefaultRule: {
    method: 'delete',
    path: '/user/v1/sync/{organizationId}/default-rule',
    queryKeys: { required: ['user_token'] },
    autoParams: { organizationId: '', user_token: '' },
  },
  migrateSyncInfo: {
    method: 'post',
    path: '/user/v1/sync/{organizationId}/migrate',
    queryKeys: { required: ['user_token'] },
    bodyKeys: { required: ['list'] },
    autoParams: { organizationId: '', user_token: '' },
  },
};

const userRequestItemSet: APIConfigSet = {
  ...orgModule,
  ...spaceModule,
  ...searchTaskModule,
  ...orgLogoModule,
  ...shareModule,
  ...codeStoreModule,
  ...weworkConfigModule,
  ...idaasConfigModule,
  ...accountCofnfigModule,
  ...statsModule,
  ...mesageModule,
  ...userModule,
  ...teamModule,
  ...favoriteModule,
  ...teamSearchModule,
  ...logSearchModule,
  ...historyVersionModule,
  ...securityScanModule,
  ...meetingModule,
  ...noviceGuidanceModule,
  ...coModule,
  ...othersModule,
  ...collaborationModule,
  ...inviteModule,
  ...recycleModule,
  ...midasPayModule,
  ...deregisterModule,
  ...electronicSignModule,
  ...cloudHerbsModule,
  ...oauthModule,
  ...ipRestrictionModule,
  ...fileCollectModule,
  ...fileApplyModule,
  ...passwordModule,
  ...fileSyncOperateModule,
};

export default userRequestItemSet;
